import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
    MouseEvent,
    useState,
} from 'react';

import Badge from './Badge';

import arrowLeftIcon from './media/arrow-left.svg';

import styles from './Header.module.scss';

const Header: FC<IProps> = (props) => {
    const [isCancelling, setIsCancelling] = useState(false);

    // Переход на cancelUrl ждёт запрос отмены, иначе браузер оборвёт его при уходе со страницы.
    // Ошибка запроса не мешает уйти со страницы
    const onCancelClick = async (event: MouseEvent<HTMLAnchorElement>) => {
        const {cancelUrl, onCancel} = props;

        if (!cancelUrl || !onCancel) {
            return;
        }

        event.preventDefault();

        if (isCancelling) {
            return;
        }

        setIsCancelling(true);

        try {
            await onCancel();
        } finally {
            window.location.href = cancelUrl;
        }
    };

    return (
        <div className={classNames(styles.header, props.className)}>
            <div className={styles.backLinkContainer}>
                {
                    props.cancelUrl &&
                    <a
                        className={styles.backLink}
                        href={props.cancelUrl}
                        onClick={onCancelClick}
                    >
                        <img
                            className={styles.backIcon}
                            src={arrowLeftIcon}
                            alt={'Back'}
                        />
                    </a>
                }
            </div>
            {
                (
                    props.merchantLogoUrl &&
                    props.isMerchantLogoDisplayedOnPaymentPage
                ) ?
                    <img
                        className={styles.merchantLogo}
                        src={props.merchantLogoUrl}
                        alt={''}
                    /> :
                    <div/>
            }
            <div className={styles.badgeContainer}>
                <Badge
                    type={props.badgeType}
                    currentSeconds={props.currentSeconds}
                />
            </div>
        </div>
    );
};

export default Header;
